import * as s from "react";
import "../../../depend/rc-field-form/es/index.mjs";
import l from "../../../depend/scroll-into-view-if-needed/dist/index.mjs";
import { getDOM as f } from "../../../depend/rc-util/lib/Dom/findDOMNode.mjs";
import { toArray as u } from "../utils/valueUtils.mjs";
import { getFieldId as d } from "../utils/fieldUtils.mjs";
import a from "../../../depend/rc-field-form/es/useForm.mjs";
function c(t) {
  return u(t).join("_");
}
function _(t, n) {
  const o = n.getFieldInstance(t), i = f(o);
  if (i)
    return i;
  const e = d(u(t), n.__INTERNAL__.name);
  return e ? document.getElementById(e) : null;
}
function A(t) {
  const [n] = a(), o = s.useRef({}), i = s.useMemo(
    () => t ?? {
      ...n,
      __INTERNAL__: {
        itemRef: (e) => (r) => {
          const m = c(e);
          r ? o.current[m] = r : delete o.current[m];
        }
      },
      scrollToField: (e, r = {}) => {
        const m = _(e, i);
        m && l(m, {
          scrollMode: "if-needed",
          block: "nearest",
          ...r
        });
      },
      getFieldInstance: (e) => {
        const r = c(e);
        return o.current[r];
      }
    },
    [t, n]
  );
  return [i];
}
export {
  A as default
};
//# sourceMappingURL=useForm.mjs.map
